import React from 'react';
import classnames from 'classnames';
import bowser from 'yola-bowser';
import noop from '../utils/noop';
import Icon from '../design-system/components/icon';

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
function ImageGrid({
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  className = null,
  items,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'number'.
  columns = null,
  activeItemId = '',
  onItemClick = noop,
  iconSize = '100%',
  onError = noop,
  ...otherImageProps
}) {
  const style = {
    gridTemplateColumns: columns
      ? `repeat(${columns}, 1fr)`
      : `repeat(auto-fit, minmax(${iconSize}, 1fr))`,
  };

  const isMobile = bowser.mobile || bowser.tablet;

  return (
    <div className={classnames('ws-image-grid', className)} style={style}>
      {items.map((item) => {
        const isActive = item.id === activeItemId;

        return (
          <div
            className={classnames('ws-image-grid__cell', {
              'ws-image-grid__cell--active': isActive,
              'ws-image-grid__cell--mobile': isMobile,
            })}
            style={{ minWidth: iconSize, minHeight: iconSize }}
            key={item.id}
          >
            {item.src ? (
              <img
                className="ws-image-grid__item"
                src={item.src}
                alt={item.title}
                onClick={() => {
                  onItemClick(item);
                }}
                onError={() => {
                  onError(item);
                }}
                {...otherImageProps}
              />
            ) : (
              <div className="ws-image-grid__broken-image">
                <Icon size={24} strokeWidth={1.3} glyph="broken-image" type="inherit" />
              </div>
            )}

            {isActive && (
              <span className="ws-image-grid__icon">
                <Icon size={12} strokeWidth={3} glyph="check" type="white" />
              </span>
            )}
            {item.isAnimated && (
              <span className="ws-image-grid__animated-icon">
                <Icon size={10} glyph="play" />
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default ImageGrid;
